import { FC, useEffect, useState, ReactElement } from "react";
import emptyProductImage from "../../assets/images/empty_product.png";
import "./newCheckout.css";
import { Header } from "../../components/Header";
import { ConfigType, PluginconfigType } from "../../contexts/AppConfigContext";
import { useAppConfig } from "../../hooks/useAppConfig";
import { useOrder } from "../../hooks/useOrder";
import {
  FrenetDeliveryMethodType,
  MeasureType,
  OrderType,
  ProductType,
  SellerInfo,
} from "../../contexts/OrderContext";
import { ProductItem } from "../../components/newCheckoutProductItem/ProductItem";
import { ChooseAddress } from "../../components/chooseAddress/chooseAddress";
import { CupomInput } from "../../components/CupomInput/cupomInput";
import { ResumeCart } from "../../components/resumeCart/resumeCart";
import { useNavigate, useParams } from "react-router-dom";
import { Loading } from "../../components/Loading";
import { LocationType } from "../../contexts/PluginspaceContext";
import { useSeller } from "../../hooks/useSeller";
import { usePluginspace } from "../../hooks/usePluginspace";
import api from "../../services/api";
import Swal from "sweetalert2";
import { cepNoMask, cpfCnpjNoMask } from "../../functions/mask";
import { floatToPrice } from "../../functions/price_functions";
import { Menu } from "../../components/Menu";
import { ButtonCheckout } from "../../components/buttonCheckout/ButtonCheckout";
import moment from "moment";
/*Toast */
import { Slide, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MainButton } from "../../components/MainButton";
import { VolumeFrenetType } from "../NewOrderInfo/NewOrderInfo";
import { useToast } from "../../hooks/useToast";
import { AddressMapType } from "../../components/ModalDelivery";
import { parse } from "path";
import { useDiscount } from "../../hooks/useDiscount";
import EmptyState from "../../components/EmptyStates/EmptyState";
import { useFaceBookPixel } from "../../hooks/useFacebookPixel";
import SellerCodeInput from "../../components/SellerCodeInput/SellerCodeInput";
import { AnyAaaaRecord } from "dns";
import { NO_VALUE_SELLER_DISCOUNT } from "../Catalog/auxCatalog";
import { useSellerInfo } from "../../contexts/sellerInfoContext";
import { set } from "zod";

type NinegridMotorConfig = {
  able: number;
  codigoEstabelecimento: number;
  maxMonetary: number;
  maxPercentage: number;
  typeDiscount: number;
};
type ProductCartType = {
  id: number;
  img: string;
  sku: string;
  variation: any;
  name: string;
  price: number;
  unitPrice: number;
  discount: number;
  discountGeral: number;
  promotional_price: number;
  quantity: number;
  code: string;
  sku_info: Array<{
    vendas: number;
    inventory: number;
    minimum_stock: number;
    measures?: MeasureType;
  }>;
};
type MapLocationType = {
  longitude: number;
  latitude: number;
};
type StoresType = {
  id: number;
  name: string;
  city: string;
  district: string;
  street: string;
  number: string;
  currentBalance: number;
  distance: string;
  locationId?: number;
  sku?: string;
};

type ItemEmptyType = {
  id: string;
  locationId: number;
  pluginspaceId: number;
  status: boolean;
  sku: string;
  price: number;
  inventory: number;
  minimumStock: number;
  promotionalPrice: number;
  name: string;
  currentBalance: number;
};

type ProductTotvsType = {
  id: number;
  chair: string;
  image: string;
  stock: number;
  codFilial: string | null;
  code: string;
  discount: number;
  productName: string;
  hash: string;
  info: string;
  notes: string;
  price: number;
  productSku: string;
  quantity: number;
  unitPrice: number;
  locationId: number;
  variation: Array<{
    grid: string;
    value: string;
  }>;
};

const NewCart: FC = (): ReactElement => {
  const navigate = useNavigate();
  const { pluginspace_id } = useParams();
  const { trackInitiateCheckout } = useFaceBookPixel()
  const {  setCpfVendorByLink, setUpdateCustomerCart, setDiscountValue, setSellerInfo,clearSellerInfo,updateCustomerCart ,sellerInfo} = useSellerInfo();
  const {
    getToken,
    pluginspaceData,
    registerAccess,
    getThisPluginspace,
    getLocations,
  } = usePluginspace();
  const toastComponent = useToast();
  const [config, setConfig] = useState<ConfigType | void>();
  const { changeCustomerAdress, getCustomerAdress } = useOrder();
  const { getAppConfig } = useAppConfig();
  const useDiscountContext = useDiscount();
  const [loading, setLoading] = useState(true);
  const [loadingHeader, setLoadingHeader] = useState(true);
  const orderContext = useOrder();
  const [calculatingDiscount, setCalculatingDiscount] = useState(false);
  const [coupon, setCoupon] = useState(localStorage.getItem(`cupom`) || "");
  const [hasCoupon, setHasCoupon] = useState(false);
  const [monetaryDiscountMax, setMonetaryDiscountMax] = useState(0);
  const [percentyDiscountMax, setPercentyDiscountMax] = useState(0);
  const [frenetMethods, setFrenetMethods] = useState<
    FrenetDeliveryMethodType[]
  >([]);
  const [defaultDeep, setDefaultDeep] = useState(0);
  const [defaultHeight, setDefaultHeight] = useState(0);
  const [defaultWeight, setDefaultWeight] = useState(0);
  const [defaultWidth, setDefaultWidth] = useState(0);

  /*Variaveis do Pedido */
  const [order, setOrder] = useState<OrderType>();
  const [total, setTotal] = useState(0);
  const [totalWithoutDiscount, setTotalWithoutDiscount] = useState(0);
  const [productStores, setProductStores] = useState<Array<StoresType>>([]);
  /*Variaveis de entrega/retirada */
  const [freightFind, setFreightFind] = useState(0);
  const [typeFreight, setTypeFreight] = useState("withdraw");

  const [stores, setStores] = useState<Array<StoresType>>([]);

  /*Valores do CEP */
  const [cep, setCep] = useState("");
  const [cepAlarm, setCepAlarm] = useState(false);
  const [findCep, setFindCep] = useState(false);
  const [valueCep, setValueCep] = useState(0);
  const [validShift, setValidShift] = useState(true);
  const [canWithdraw, setCanWithdraw] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  /* */
  const [locations, setLocations] = useState<Array<LocationType>>([]);
  const { getTokenSeller } = useSeller();

  const [ninegridMotorAble, setNinegridMotorAble] = useState(false);
  const [ninegridMotorConfig, setNinegridMotorConfig] =
    useState<NinegridMotorConfig>();
  const [totvsVarejoAble, setTotvsVarejoAble] = useState(false);
  const [totvsMotorAble, setTotvsMotorAble] = useState(false);

  const [valueWithDraw, setValueWithDraw] = useState(0);
  const [sellerCodeAble, setSellerCodeAble] = useState(false)

  const [minimumValue, setMinimumValue] = useState(0);

  /** Desconto */
  //Tipo de Desconto Geral ou Vendedor
  const [geralDiscount, setGeralDiscount] = useState(false);

  /**PluginsPceType */
  const [typePluginspace, setTypePluginspace] = useState("");

  /* Variaveis para o Toast */
  //const toast = useToast()

  const [addressMapLocation, setAddressMapLocation] = useState<AddressMapType | null>(null);
  const [position, setPosition] = useState({ latitude: 0, longitude: 0 });

  /* Seller Code */
  const [sellerCode, setSellerCode] = useState("");

  async function removeSellerCode() {
    setSellerCode('')
    clearSellerInfo();
  }

  const getUserPosition = async () => {
    try {
      setLoading(true);
      navigator.geolocation.getCurrentPosition(
        async (positionGet) => {
          setPosition({
            latitude: positionGet.coords.latitude,
            longitude: positionGet.coords.longitude,
          });
          await api
            .post(
              `/api/maps/cep-by-geolocation`,
              {
                latitude: positionGet.coords.latitude,
                longitude: positionGet.coords.longitude,
              },
              {
                headers: {
                  Authorization: `Bearer ${await getToken()}`,
                },
              }
            )
            .then(async (response) => {
              if (
                response.data &&
                response.data.success &&
                response.data.data &&
                response.data.data.length > 0
              ) {
                setCep(response.data.data[0].cep);
                setAddressMapLocation({
                  cep: response.data.data[0].cep,
                  city: response.data.data[0].city,
                  street: response.data.data[0].street,
                  district: response.data.data[0].district,
                  streetNumber: response.data.data[0].streetNumber,
                  state: response.data.data[0].state,
                  latLng: {
                    latitude: positionGet.coords.latitude,
                    longitude: positionGet.coords.longitude,
                  },
                });

                await getStores(response.data.data[0].cep, {
                  latitude: positionGet.coords.latitude,
                  longitude: positionGet.coords.longitude,
                });
                if (typeFreight === "delivery" && valueCep) {
                  setFreightFind(valueCep);
                }
              } else {
                toastComponent.openToast(
                  "error",
                  `Impossível recuperar localização do usuário`,
                  5000
                );
              }
            })
            .catch((e) => {
              setLoading(false);
              toastComponent.openToast(
                "error",
                `Impossível recuperar localização do usuário`,
                5000
              );
            });
        },
        () => {
          setLoading(false);
          toastComponent.openToast(
            "warning",
            `É necessário ativar a localização para usá-la`,
            5000
          );
        }
      );
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  async function getConfig() {
    setLoadingHeader(true);
    const conf = await getAppConfig();

    if (conf) {
      const value = conf!.content.pdv.withDrawFee
        ? parseFloat(conf!.content.pdv.withDrawFee.toString())
        : 0;

      setMinimumValue(
        conf.content.pdv.minimumValue ? conf.content.pdv.minimumValue : 0
      );
      setValueWithDraw(value);
      setFreightFind(value);

      setSellerCodeAble(conf.content.pdv.sellerCode)
    }

    setLoadingHeader(false);

    setConfig(conf);
    return conf;
  }

  async function loadOrder() {
    const newOrder = await orderContext.getOrder();
    const totalValues = await orderContext.totalValueOrder();
    setTotal(totalValues.total);
    setTotalWithoutDiscount(totalValues.totalWithoutDiscount);
    setOrder(newOrder);
  }

  async function getVerifyShift() {
    try {
      const pgData = await getThisPluginspace();
      const response = await api.post(
        `api/location-operation/verify`,
        {},
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      );
      if (pgData && pgData.type === "food") {
        setValidShift(response.data && response.data.success);
      } else {
        setValidShift(true);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function verifyFrenet(cep: string) {
    const orderNow = await orderContext.getOrder();
    if (orderNow && orderNow.products) {
      let volumes: VolumeFrenetType[] = [];
      let shipmentInvoiceValue = 0;
      orderNow.products.forEach((prod) => {
        volumes.push({
          Height: prod.measures?.height || Number(defaultHeight),
          Length: prod.measures?.lenght || Number(defaultDeep),
          Weight: prod.measures?.weight || Number(defaultWeight),
          Width: prod.measures?.width || Number(defaultWidth),
          Quantity: prod.quantity,
          SKU: prod.sku,
        });
        shipmentInvoiceValue +=
          prod.unitPrice !== prod.promotionalPrice &&
            prod.promotionalPrice !== 0
            ? prod.promotionalPrice
            : prod.unitPrice;
      });
      return await api
        .post(
          "/api/frenet/quote",
          {
            recipientCep: cep,
            shipmentInvoiceValue,
            shippingItemArray: volumes,
            recipientCountry: "BR",
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          const frenetResponse = response.data;
          if (
            frenetResponse.success &&
            frenetResponse.data &&
            frenetResponse.data.ShippingSevicesArray &&
            frenetResponse.data.ShippingSevicesArray.length > 0
          ) {
            const newFrenetItens =
              frenetResponse.data.ShippingSevicesArray.filter(
                (frenetItem: FrenetDeliveryMethodType) => !frenetItem.Error
              );
            setFrenetMethods(newFrenetItens);
            return newFrenetItens;
          } else {
            setFrenetMethods([]);
            return [];
          }
        })
        .catch((err) => {
          console.log(err);
          setFrenetMethods([]);
          return [];
        });
    }
  }

  async function verifyTotvs() {
    await api
      .post(
        `/api/pluginconfig/filter`,
        {
          plugintemplateId: 105,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data.data.length > 0) {
          const configData: PluginconfigType = response.data.data[0];

          if (configData.content.able === "1") {
            setTotvsVarejoAble(true);
            if (configData.content.habilitarMotorPromocao === "1") {
              setTotvsMotorAble(true);
              if (orderContext.order) {
                const productsCart: ProductType[] =
                  orderContext.order?.products.map((product) => {
                    product.promotionalPrice = product.unitPrice;
                    return product;
                  });
                setOrder({
                  products: productsCart,
                });
                await orderContext.changeOrderByGuidCart(
                  productsCart,
                  orderContext
                );
              }
              orderContext.setDiscountGeneral(0);
              await orderContext.totalValueOrder();
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //verificação do motor de promoção ninegrid
  async function verifyNinegridProm() {
    await api
      .post(
        `/api/pluginconfig/filter`,
        {
          plugintemplateId: 107,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data.data.length > 0) {
          const configData: PluginconfigType = response.data.data[0];
          if (configData.content.able === "1") {
            setNinegridMotorAble(true);
            setNinegridMotorConfig(configData.content);

            setGeralDiscount(
              configData.content.typeDiscount == 0 ? true : false
            );

            setMonetaryDiscountMax(parseFloat(configData.content.maxMonetary));
            setPercentyDiscountMax(
              parseFloat(configData.content.maxPercentage)
            );
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function validateCart(timeCart: string): Promise<{
    valid: boolean;
    msg: string;
  }> {
    try {
      let valid = false;
      const configLocal = await getAppConfig();
      const pg = await getThisPluginspace();

      const gtmValue =
        !pg || !pg?.gmt?.split(":")[0] ? -3 : parseInt(pg.gmt.split(":")[0]);

      const carrinhoDataCriacao = moment
        .utc(timeCart)
        .utcOffset(gtmValue)
        .seconds(0);
      const now = moment().utcOffset(gtmValue).seconds(0); // Data e hora atuais ajustadas para o GMT

      const hour = configLocal
        ? configLocal.content.pdv.sellerCartExpirationTime.split(":")[0]
        : "2";
      const minute = configLocal
        ? configLocal?.content.pdv.sellerCartExpirationTime.split(":")[1]
        : "0";

      const validTimeCart = carrinhoDataCriacao
        .clone()
        .add(parseInt(hour), "hours")
        .add(parseInt(minute), "minutes");

      valid = validTimeCart.isAfter(now) || validTimeCart.isSame(now, "second");
      const timeDifference = now.diff(validTimeCart, "minutes");
      const hours = Math.floor(timeDifference / 60);
      const minutes = timeDifference % 60;

      let msg = "";

      if (hours && minutes) {
        msg += `${hours} hora(s) e ${minutes} minuto(s) `;
      } else if (minutes) {
        msg += `${minutes} minuto(s) `;
      }

      return {
        valid: valid,
        msg: msg,
      };
    } catch (er) {
      return {
        valid: false,
        msg: ``,
      };
    }
  }

  async function getCart(guid: string) {
    await api
      .get(`/api/customerCart/guid/${guid}`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const order = response.data.data[0];

        const isValid = await validateCart(order.created);
        if (!isValid || !isValid.valid) {
          let text =
            "O carrinho do vendedor está expirado. Favor entrar em contato com o seu vendedor";
          if (isValid && isValid.msg) {
            text = `O tempo limite do carrinho expirou após ${isValid.msg}. Por favor, entre em contato com o vendedor`;
          }

          Swal.fire({
            icon: "warning",
            titleText: "Carrinho expirado",
            text: text,
          }).then(() => navigate(`/${pluginspace_id}/category`));
          return;
        }

        if (order.status != "open") {
          Swal.fire({
            icon: "warning",
            titleText: "Carrinho já utilizado",
            text: "O carrinho do vendedor já foi utilizado. Favor entrar em contato com o seu vendedor",
          });
          return;
        }

        if (
          response.data.data &&
          response.data.data[0] &&
          response.data.data[0].cpfSeller
        ) {
          orderContext.setSellerCpfCnpj(response.data.data[0].cpfSeller);
        }
        orderContext.setCustomer({
          name: order.customerName,
          telephone: order.phoneCustomer,
          cpf: order.cpfCustomer,
        });

        orderContext.setGuidCart(guid);

        orderContext.changeCustomerDocument(order.cpfCustomer);

        let productsCart: any = [];

        if (order.jsonCart.products) {
          productsCart = order.jsonCart.products.map(
            (product: ProductCartType) => {
              const variationFormated: any = {};
              product.variation.map((variation: any) => {
                variationFormated[variation.grid] = variation.value
                  ? variation.value
                  : variation.valor;
              });
              const newProduct: ProductType = {
                id: product.id,
                image: product.img,
                code: product.code,
                locationId: order.locationId,
                name: product.name,
                promotionalPrice: product.promotional_price,
                quantity: product.quantity,
                sku: product.sku,
                stock: product.sku_info[0].inventory,
                unitPrice: product.unitPrice,
                variation: variationFormated,
                pluginspaceHash: pluginspace_id ? pluginspace_id : "",
                outStock: false,
                measures: product.sku_info[0].measures
                  ? product.sku_info[0].measures
                  : null,
              };
              return newProduct;
            }
          );
        } else {
          productsCart = order.jsonCart.map((product: ProductCartType) => {
            const variationFormated: any = {};
            product.variation.map((variation: any) => {
              variationFormated[variation.grid] = variation.value
                ? variation.value
                : variation.valor;
            });
            const newProduct: ProductType = {
              id: product.id,
              image: product.img,
              code: product.code,
              locationId: order.locationId,
              name: product.name,
              promotionalPrice: product.promotional_price,
              quantity: product.quantity,
              sku: product.sku,
              stock: product.sku_info[0].inventory,
              unitPrice: product.unitPrice,
              variation: variationFormated,
              pluginspaceHash: pluginspace_id ? pluginspace_id : "",
              outStock: false,
              measures: product.sku_info[0].measures
                ? product.sku_info[0].measures
                : null,
            };
            return newProduct;
          });
        }

        setOrder({
          products: productsCart,
        });
        await orderContext.changeOrderByGuidCart(productsCart, orderContext);

        await orderContext.setShouldUpdadeCustomerCart(true);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function findCustomer(cpfOrCnpj: string) {
    const cpfWithouthMask = cpfCnpjNoMask(cpfOrCnpj);

    await api
      .post(
        `/api/customer/filter`,
        {
          cpf: cpfWithouthMask,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data.data.length > 0) {
          const customerAddresses = response.data.data[0].customerAddresses;
          orderContext.changeCustomerDocument(cpfOrCnpj);
          if (customerAddresses.length > 0) {
            setCep(customerAddresses[0].zipCode);
            orderContext.changeCustomerAdress({
              cep: customerAddresses[0].zipCode,
            });
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function loadAll() {
    setLoading(true);
    let config;
    const tk = getTokenSeller();
    if (tk && tk.profile == "seller") {
      navigate(`/${pluginspace_id}/cart`);
    } else {
      config = await getConfig();
    }

    await getVerifyShift();
    await verifyTotvs();
    await verifyNinegridProm();
    await validadeIfCupomExist();

    //usado para verificar se deve ou não criar um carrinho ou atualizar
    await orderContext.getGuidCartNew();
    await orderContext.getshouldUpdadeCart();

    await loadOrder();

    const newOrder = await orderContext.getOrder();
    const newProducts = newOrder.products.filter((product) => !product.orderId);
    newOrder.products = newProducts;
    await orderContext.setProductsOrder(newProducts);
    setOrder(newOrder);

    if(sellerCodeAble && sellerInfo.id && sellerInfo.sellerCode) {
      setSellerCode(sellerInfo.sellerCode)
      await findVendorByCode(sellerInfo.sellerCode)
    }

    const loc = await getLocations();

    setLocations(loc);

    const pgData = await getThisPluginspace();
    if (pgData && pgData.type) {
      setTypePluginspace(pgData.type);
    }

    if (window.location.search && window.location.search !== "") {
      const guidCart = window.location.search.split("=")[1];
      await getCart(guidCart);

      const customer = await orderContext.getCustomer();

      const documento = await orderContext.getCustomerDocument();
      if (documento) await findCustomer(documento);
    }

    setLoading(false);
  }

  async function getConfigFrenet() {
    await api
      .post(
        `/api/pluginconfig/filter`,
        {
          plugintemplateId: 119,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then((res) => {
        const config = res.data.data.filter(
          (el: any) =>
            el.content?.deep &&
            el.content?.height &&
            el.content?.weight &&
            el.content?.width
        );
        if (config.length > 0) {
          setDefaultDeep(config[0].content.deep);
          setDefaultHeight(config[0].content.height);
          setDefaultWeight(config[0].content.weight);
          setDefaultWidth(config[0].content.width);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function loadAllData() {
    try {
      setLoading(true);
      await getConfig();
      registerAccess("cart");
      await loadAll();
      await getConfigFrenet();
      // await calculateNinegridDiscountOnPageInit(true, false)
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }

  function validatePurchaseMin() {
    return total >= minimumValue ? true : false;
  }
  async function validCep(cep: string) {
    return await api
      .get(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`)
      .then((response) => {
        if (response.data.erro) {
          return false;
        }
        return true;
      })
      .catch(() => {
        return false;
      });
  }

  async function findCepDelivery(cepSended?: string, configuration?: any) {
    const noMaskCep = cepNoMask(cepSended ? cepSended : cep);

    setLoading(true);
    let frenetItems: FrenetDeliveryMethodType[] = [];
    if (noMaskCep) {
      frenetItems = await verifyFrenet(noMaskCep);
    }
    const isValidCep = await validCep(noMaskCep);

    if (!isValidCep && noMaskCep) {
      setLoading(false);
      setFreightFind(0);
      toastComponent.openToast("warning", `Informe um CEP válido`, 5000);
      return null;
    }

    if (config) {
      const value = config!.content.pdv.withDrawFee
        ? parseFloat(config!.content.pdv.withDrawFee.toString())
        : 0;

      setValueWithDraw(value);
      setFreightFind(value);
    }
    let urlSearchValid = "";
    switch (
    configuration
      ? configuration?.content.pdv.restrictCep
      : config?.content.pdv.restrictCep
    ) {
      case "cep":
        urlSearchValid = `/api/zip-code/valid/${noMaskCep}`;
        break;
      case "area":
        urlSearchValid = `/api/delivery/valid/${noMaskCep}`;
        break;
      case "mapa":
        urlSearchValid = `/api/delivery-area/valid/${noMaskCep}`;
        break;
      default:
        urlSearchValid = `/api/zip-code/valid/${noMaskCep}`;
        break;
    }
    await api
      .get(urlSearchValid, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const findedCeps = response.data.data;

        if (findedCeps.length > 0 && findedCeps[0].valor >= 0) {
          setFindCep(true);
          setValueCep(findedCeps[0].valor);
          setCanWithdraw(true);
        } else {
          if (!frenetItems || !frenetItems.length) {
            toastComponent.openToast(
              "warning",
              `Não foi possível encontrar formas de envio para o CEP`,
              5000
            );
          }

          setFindCep(false);
          setCanWithdraw(false);
        }
        setLoading(false);
      })
      .catch((err) => {
        setFindCep(false);
        setCanWithdraw(false);
        console.log(err);
        setLoading(false);
      });
  }

  async function findCepAdress(cep2: string) {
    return await api
      .get(`https://viacep.com.br/ws/${cep2.replace("-", "")}/json/`)
      .then((response) => {
        if (response.data.erro) {
          toastComponent.openToast(
            "warning",
            `Verifique se o CEP foi digitado corretamente`,
            5000
          );
          return false;
        } else {
          changeCustomerAdress({ cep: response.data.cep });
          setCep(response.data.cep);

          return true;
        }
      })
      .catch(() => {
        Swal.fire({
          icon: "warning",
          title: "CEP inválido!",
          text: "Verifique se o CEP foi digitado corretamente.",
        });
        return false;
      });
  }

  /*Função usada para verificar se o cep é valido e se retorna */
  async function getStores(cepSended?: string, latLng?: MapLocationType) {
    setLoading(true);
    const cepUse = cepSended ? cepSended : cep;
    const noMaskCep = cepNoMask(cepUse);

    // Verificar se o CEP é válido
    const isValidCep = await validCep(noMaskCep);
    if (!isValidCep) {
      setLoading(false);
      toastComponent.openToast("warning", `Informe um CEP válido`, 5000);
      return;
    }

    // Enviar requisição para buscar lojas
    await api
      .post(
        `/api/variations/skuzipcode`,
        {
          zipcode: noMaskCep,
          skus: [],
          restrictCep: config?.content.pdv.restrictCep || "cep",
          noVerifyStock:
            config && config.content.pdv.showOutStock ? true : false,
          locationId: locations.find((el) => el.type == "internal")?.id || null,
          latLng: latLng || null,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        let newStores: Array<StoresType> = [];

        if (!response.data || response.data.success === false) {
          setLoading(false);

          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text:
              response.data.dataEmpty && response.data.dataEmpty.length > 0
                ? `Produtos: ${response.data.dataEmpty
                  .map((u: any) => u.name)
                  .join(", ")} sem estoque`
                : "Não foi possível encontrar formas de envio para o CEP.",
          });

          setStores([]);
          return;
        }

        // Filtrando lojas
        response.data.forEach((str: StoresType) => {
          const newStore = {
            id: str.id,
            name: str.name,
            city: str.city,
            district: str.district,
            street: str.street,
            number: str.number,
            distance: str.distance,
            currentBalance: str.currentBalance,
          };
          const findedStore = newStores.find(
            (findStore) =>
              findStore.name === newStore.name &&
              findStore.distance === newStore.distance
          );
          if (!findedStore) {
            newStores.push(newStore);
            localStorage.setItem("storeAddress", JSON.stringify(newStore));
          }
        });

        setStores(newStores);
        setLoading(false);

        findCepDelivery(noMaskCep);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        Swal.fire({
          icon: "warning",
          title: "Erro!",
          text: "Falha ao buscar lojas para o CEP",
        });
      });
  }

  const verifyStock = async () => {
    setLoading(true);
    const locationType = locations.find((loc) => typeFreight === loc.code);
    let success = true;
    if (locationType && !(config && config.content.pdv.showOutStock)) {
      const orderSave = await orderContext.getOrder();
      await api
        .post(
          `/api/variations/sku-inventory`,
          {
            skus:
              orderSave && orderSave.products
                ? orderSave.products.map((p) => p.sku)
                : [],
            locationId: locationType.id,
            status: true,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          if (response.data && response.data.success && response.data.data) {
            const itemsSku = response.data.data.filter(
              (product: any) => product.inventory <= 0
            );
            if (itemsSku.length > 0) {
              let skusEmpty = itemsSku.map((item: ItemEmptyType) => item.sku);
              const newProducts = orderSave.products.map((produto) => {
                if (skusEmpty.includes(produto.sku)) produto.outStock = true;
                return produto;
              });
              Swal.fire({
                icon: "warning",
                title: "Atenção!",
                text: `Produtos: ${itemsSku
                  .map((u: any) => u.name)
                  .join(", ")} sem estoque`,
              });
              setOrder({
                products: newProducts,
              });
              success = false;
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Erro!",
              text: `Falha ao recuperar estoque de produtos`,
            });
            success = false;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Erro!",
            text: `Falha ao recuperar estoque de produtos`,
          });
          success = false;
        });
    }
    setLoading(false);
    return success;
  };

  const createCart = async () => {
    if (updateCustomerCart) {
      const link = `${window.location.origin}/${window.location.pathname.split("/")[1]
        }/cart`;

      if (!orderContext.guidCart) {
        //create
        const jsonCart = {
          products: order!.products,
          address: {},
          type: typeFreight,
          freight: freightFind,
          totalDiscount: 0,
        };

        const objCustomerCart = {
          customerName: "",
          cpfCustomer: "",
          phoneCustomer: "",
          cpfSeller: orderContext.cpfVendor,
          jsonCart: jsonCart,
          locationId: order!.products[0].locationId,
          urlcart: link + "?cart=",
        };
        await api
          .post(`/api/customerCart`, objCustomerCart, {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          })
          .then(async (response) => {
            if (response.status === 201) {
              const data = response.data.dados;
              orderContext.setGuidCart(data.guid);

              orderContext.setGuidCartNew(data.guid);
            } else {
              setLoading(false);
              Swal.fire({
                icon: "error",
                title: "Erro ao criar carrinho",
              });
            }
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Erro ao criar carrinho",
            });
            console.log(err);
            setLoading(false);
          });

        return;
      }
    }

    return;
  };

  async function calculateDiscount() {
    if (totvsVarejoAble && coupon) {
      setLoading(true);
      const products = order?.products.map((product) => ({
        hash: window.btoa(product.code),
        id: product.id,
        productName: product.name,
        image: product.image,
        stock: product.stock,
        code: product.code,
        locationId: product.locationId,
        quantity: product.quantity,
        discount:
          product.promotionalPrice !== product.unitPrice &&
            product.promotionalPrice !== 0
            ? parseInt(
              ((product.unitPrice - product.promotionalPrice) * 100).toFixed(
                0
              )
            )
            : 0,
        price:
          product.promotionalPrice !== product.unitPrice &&
            product.promotionalPrice !== 0
            ? parseInt(
              ((product.unitPrice - product.promotionalPrice) * 100).toFixed(
                0
              )
            )
            : parseInt((product.unitPrice * 100).toFixed(0)),
        unitPrice: parseInt((product.unitPrice * 100).toFixed(0)),
        codFilial: pluginspaceData?.id,
        info: "",
        chair: "",
        notes: "",
        productSku: product.sku,
        variation: Object.entries(product.variation).map((obj) => ({
          grid: obj[0],
          value: obj[1],
        })),
      }));
      await api
        .post(
          "/api/totvsPromotionEngine/calculatePromotion",
          {
            "couponPromotionalCode--": coupon,
            discountGeneral: 0.0,
            products,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          setLoading(false);
          if (response.data) {
            const newProducts: Array<ProductType> = response.data.products.map(
              (product: ProductTotvsType) => {
                let objVar: any = {};
                product.variation.forEach((variation) => {
                  objVar[variation.grid] = variation.value;
                });
                return {
                  id: product.id,
                  name: product.productName,
                  image: product.image,
                  unitPrice: parseFloat((product.unitPrice / 100).toFixed(2)),
                  promotionalPrice: product.price
                    ? parseFloat(
                      ((product.unitPrice - product.discount) / 100).toFixed(
                        2
                      )
                    )
                    : parseFloat(
                      ((product.unitPrice - product.discount) / 100).toFixed(
                        2
                      )
                    ),
                  quantity: product.quantity,
                  stock: product.stock,
                  sku: product.productSku,
                  variation: objVar,
                  code: product.code,
                  locationId: product.locationId,
                  pluginspaceHash: pluginspace_id,
                };
              }
            );

            await orderContext.changeOrderByGuidCart(newProducts, orderContext);
            orderContext.setDiscountGeneral(
              response.data.totalAmountDiscount
                ? response.data.totalAmountDiscount
                : 0
            );
            setHasCoupon(true);
            toastComponent.openToast(
              "success",
              `O cupom de desconto ${coupon} foi aplicado`,
              5000
            );
          } else {
            toastComponent.openToast(
              "error",
              `O cupom de desconto ${coupon} não é válido`,
              5000
            );
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          toastComponent.openToast(
            "error",
            `O cupom de desconto ${coupon} não é válido`,
            5000
          );
          return null;
        });
    }
  }

  useEffect(() => {
    loadAllData();
  }, []);

  useEffect(() => {
    if (!calculatingDiscount) loadOrder();
  }, [orderContext]);

  async function chooseAddress() {
    const purchaseMin = validatePurchaseMin();

    if (!purchaseMin) {
      toastComponent.openToast(
        "warning",
        `A sua compra não atingiu o valor mínimo de ${floatToPrice(
          minimumValue
        )}`,
        5000
      );

      return;
    }
    const locationType = locations.find((loc) => typeFreight === loc.code);
    if (locationType) {
      const storeOutStock: StoresType | undefined = productStores.find(
        (str) => str.locationId === locationType.id && str.currentBalance <= 0
      );
      if (storeOutStock && !(config && config.content.pdv.showOutStock)) {
        const prodFinded: ProductType | undefined = order?.products.find(
          (prod) => prod.sku === storeOutStock.sku
        );
        if (prodFinded) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: `Produto: ${prodFinded.name} sem estoque`,
          });
          return;
        }
      }
    }
    orderContext.setFreight(freightFind);
    //orderContext
    navigate(`/${pluginspace_id}/new-customer`);
    //setModalIsOpen(true);
  }

  async function validateDiscoutCoupon(showAlert?: boolean) {
    try {
      if (coupon) {
        const payload = {
          nameCoupom: coupon,
        };

        const response = await api
          .post("/api/discount-coupons/validCupons", payload, {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          })
          .then(async (response) => {
            if (response.data && response.data.success) {
              return {
                success: true,
                data: response.data,
              };
            }
            if (!showAlert) {
              toastComponent.openToast("warning", "Cupom inválido", 5000);
            }
            return {
              success: false,
              data: [],
            };
          })
          .catch((err) => {
            let erro = "Cupom inválido";

            if (
              err.response &&
              err.response.data &&
              err.response.data.message &&
              err.response.data.message !=
              'Cannot read properties of undefined (reading "message")'
            ) {
              erro = err.response.data.message;
            }

            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              switch (err.response.data.message) {
                case "Nenhum registro encontrado":
                  erro = "Cupom não encontrado";
              }
            }
            if (!showAlert) {
              toastComponent.openToast("warning", erro, 5000);
            }
            return {
              success: false,
              data: [],
            };
          });

        return response;
      }
    } catch (error) {
      !showAlert && toastComponent.openToast("warning", "Cupom inválido", 5000);
      return {
        success: false,
        data: [],
      };
    }
  }

  async function validateCartToCupom(): Promise<{
    success: boolean;
    msg: string;
  }> {
    try {
      const newOrder = await orderContext.getOrder();

      // Verifica se existe pelo menos 1 produto com promotionalPrice diferente de unitPrice
      const hasPromotional = newOrder.products.some(
        (product) =>
          product.promotionalPrice &&
          product.promotionalPrice !== product.unitPrice
      );

      if (hasPromotional) {
        return {
          success: false,
          msg: "Cupom não é aplicável pois existem itens promocionais no seu carrinho",
        };
      }

      return {
        success: true,
        msg: "Carrinho válido para aplicação de cupom",
      };
    } catch (error) {
      return {
        success: false,
        msg: "Erro ao validar carrinho",
      };
    }
  }

  async function calculateNinegridDiscount(doNotShow?: boolean) {
    try {
      if (ninegridMotorAble) {
        setLoading(true);
        setCalculatingDiscount(true);

        const cartIsValid = await validateCartToCupom();

        if (!cartIsValid || !cartIsValid.success) {
          setCalculatingDiscount(false);
          setLoading(false);
          if (!doNotShow) {
            toastComponent.openToast("warning", cartIsValid.msg, 8000);
          }
          return;
        }

        const couponIsValid = await validateDiscoutCoupon(doNotShow);

        if (!couponIsValid || !couponIsValid.success) {
          setCalculatingDiscount(false);
          setLoading(false);
          return;
        }

        const couponData = couponIsValid.data.data[0];
        const newOrder = await orderContext.getOrder();

        const productsToGiveDiscout = newOrder.products.map((product: any) => ({
          hash: window.btoa(product.code),
          id: product.id,
          productName: product.name,
          image: product.image,
          stock: product.stock,
          code: product.code,
          locationId: product.locationId,
          quantity: product.quantity,
          oldDiscountPrice: product.oldDiscountPrice
            ? product.oldDiscountPrice
            : product.promotionalPrice,
          price: parseInt((product.unitPrice * 100).toFixed(0)),
          unitPrice: parseInt((product.unitPrice * 100).toFixed(0)),
          codFilial: pluginspaceData?.id,
          discountValue: 0,
          discountPercentageValue: 0,
          info: "",
          chair: "",
          notes: "",
          productSku: product.sku,
          measures: product.measures,
          variation: Object.entries(product.variation).map((obj) => ({
            grid: obj[0],
            value: obj[1],
          })),
        }));

        const payload = {
          couponPromotionalCode: couponData.nameCoupom,
          totalAmountDiscount: parseFloat(couponData.valueDiscount),
          percentageDiscountTotalAmount: parseFloat(
            couponData.percentageDiscount
          ),
          discountGeneral: 0,
          products: productsToGiveDiscout,
        };

        try {
          const response = await api.post(
            "/api/discount-enginer/calcdiscount",
            payload,
            {
              headers: {
                Authorization: `Bearer ${await getToken()}`,
              },
            }
          );

          if (response.data) {
            const data = response.data.data.data;
            let totalDescontoCupom = 0;

            if (data.totalAmountDiscount) {
              totalDescontoCupom = data.totalAmountDiscount;
            } else if (data.percentageDiscountTotalAmount) {
              const totalDesconto = data.products.reduce(
                (total: number, product: any) => {
                  if (product.price !== product.unitPrice) {
                    const totalProdutoPreco =
                      product.unitPrice * product.quantity;
                    const descontoProdutoTotal = product.price;
                    const descontoPorProduto =
                      totalProdutoPreco - descontoProdutoTotal;
                    return total + descontoPorProduto;
                  }
                  return total;
                },
                0
              );
              totalDescontoCupom = parseFloat((totalDesconto / 100).toFixed(2));
            }

            useDiscountContext.setCoupon(
              payload.couponPromotionalCode,
              totalDescontoCupom
            );
            setHasCoupon(true);

            if (!doNotShow) {
              toastComponent.openToast(
                "success",
                "Cupom utilizado com sucesso",
                7000
              );
            }
          }
        } catch (err) {
          setLoading(false);
          toastComponent.openToast("warning", "Cupom não foi aplicado", 7000);
          console.log(err);
        }

        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setCalculatingDiscount(false);
    }
  }

  async function removeDiscount() {
    try {
      const newOrder = await orderContext.getOrder();

      // Produtos que possuem o campo hasDiscount
      const produtosWithCupomDiscount = newOrder.products.filter(
        (product: any) => product.withDiscout
      );
      // Produtos que não possuem o campo hasDiscount
      const produtosWithoutCupomDiscount = newOrder.products.filter(
        (product: any) => !product.withDiscout
      );

      setLoading(true);
      setCalculatingDiscount(true);
      const productsRemoveDiscout: Array<any> = produtosWithCupomDiscount.map(
        (product: any) => {
          let objVar: any = product.variation;
          return {
            id: product.id,
            name: product.name,
            image: product.image,
            unitPrice: parseFloat(product.unitPrice.toFixed(2)),
            oldDiscountPrice: product.oldDiscountPrice,
            promotionalPrice: product.oldDiscountPrice,
            quantity: product.quantity,
            stock: product.stock,
            sku: product.sku,
            measures: product.measures,

            variation: objVar,
            code: product.code,
            locationId: product.locationId,
            pluginspaceHash: pluginspace_id,
            withDiscout: true,
          };
        }
      );

      setOrder({
        products: [...productsRemoveDiscout, ...produtosWithoutCupomDiscount],
      });

      await orderContext.changeOrderByGuidCart(
        [...productsRemoveDiscout, ...produtosWithoutCupomDiscount],
        orderContext
      );

      setCoupon("");
      setHasCoupon(false);
      toastComponent.openToast("success", "Cupom removido com sucesso", 5000);
      /* Usado para Validar os descontos retornoados */

      useDiscountContext.clearDiscounts();

      setLoading(false);
      setCalculatingDiscount(false);
    } catch (error) {
      setLoading(false);
      setCalculatingDiscount(false);
    }
  }

  //funcao utilizada para validar se o cupom ja foi aplicado
  // anteriormente e se sim, realizar os bloqueios do front e ou demonstrar que existe um cupom.
  async function validadeIfCupomExist() {
    try {
      const cupom = useDiscountContext.data.couponCode;
      if (cupom) {
        setCoupon(cupom);
        setHasCoupon(true);
      }
    } catch (error) {
      console.log(error);
      setHasCoupon(false);
    }
  }

  function goToCategory() {
    navigate(`/${pluginspace_id}/category`)
  }

  async function findVendorByCode(code: string): Promise<any> {
    try {

      if (!code) {
        return
      }

      setLoading(true);

      const discountValue = await getVendorInfoByCode(code);

      if (!discountValue.sellerInfo.id) {
        setSellerCode("");
        Swal.fire({
          icon: "warning",
          title: "Atenção!",
          text: "Código de vendedor inválido",
        });
        return NO_VALUE_SELLER_DISCOUNT;
      }
      const sellerInfo = discountValue.sellerInfo;

      setCpfVendorByLink(sellerInfo.cpf);
      setUpdateCustomerCart(true);
      setDiscountValue(discountValue.discountValue)
      setSellerInfo(discountValue.sellerInfo);

      return discountValue;

    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Erro!",
        text: "Falha ao buscar informações do vendedor",
      });
      return null
    }finally {
      setLoading(false);
    }
  }

  async function getVendorInfoByCode(code: string): Promise<{
    discountValue: number;
    sellerInfo: SellerInfo;
  }> {
    return await api
      .post(
        `/api/users/filter`,
        {
          type: 'seller',
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (res: any) => {
        if (res.data) {
          const sellerData = res.data.data.find((e: any) => e.sellerCode === code.toString());

          if (sellerData) {
            const seller: SellerInfo = {
              cpf: sellerData.cpf,
              image: sellerData.image,
              email: sellerData.email,
              id: sellerData.id,
              name: sellerData.name,
              sellerCode: sellerData.sellerCode,
              numberPhone: sellerData.numberPhone,
              pluginspaceId: parseInt(sellerData.pluginspaceId),
            };
            return {
              discountValue: 0,
              sellerInfo: seller,
            };
          }
        }

        return NO_VALUE_SELLER_DISCOUNT;
      })
      .catch((err) => {
        console.log(err);
        return NO_VALUE_SELLER_DISCOUNT;
      });
  }

  return (
    <div className="newCheckout">
      <div className="newCheckout-content">
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {loading ? (
          <div
            style={{
              width: "100%",
              height: `calc(${loadingHeader ? "100vh" : "100vh - 2em"})`,
            }}
          >
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className="body">
            <div className="content">
              <div className="title">
                <h3>Carrinho de compras</h3>
              </div>
              {/* Mostrar Carrinho de compras do cliente */}
              {order && !order.products.length ? (
                <div className={"empty_product"}>
                  <EmptyState type={"cart"} textButton={"Procurar"} colorIcon={config?.webappcolor.iconsheader
                    ? config.webappcolor.iconsheader
                    : "#CEA127"}
                    noShowBackground
                    action={goToCategory}

                  />

                </div>
              ) : (
                <>
                  <div className="carrinho-compras">
                    {order &&
                      order.products.map((prod) => (
                        <ProductItem
                          product={prod}
                          key={prod.id}
                          showOutStock={config?.content.pdv.showOutStock}
                          motorTotvs={false}
                          canChange={true}
                          hasCoupon={hasCoupon}
                          omitGrid={config?.content?.pdv?.omitGrid}
                        />
                      ))}
                  </div>

                  {/* Escolha de entrega ou retirada */}
                  <ChooseAddress
                    deliveryActive={
                      config && config.content.pdv.internalDelivery
                        ? true
                        : false
                    }
                    findCep={findCep}
                    withDrawValue={valueWithDraw}
                    deliveryDrawValue={valueCep}
                    setCep={setCep}
                    cep={cep}
                    getStores={getStores}
                    findCepDelivery={findCepDelivery}
                    setTypeFreight={setTypeFreight}
                    setFreightFind={setFreightFind}
                    typeFreight={typeFreight}
                    stores={stores}
                    frenetMethods={frenetMethods}
                    findLocation={config?.content.pdv.ableUserLocation}
                    config={config}
                    getPosition={getUserPosition}
                    openModal={openModal}
                    setOpenModal={setOpenModal}
                    selectValue={false}
                  />

                  {/* Cupom  totvs */}
                  {totvsVarejoAble && !ninegridMotorAble && (
                    <CupomInput
                      cupon={coupon}
                      setCupon={setCoupon}
                      hasCoupon={hasCoupon}
                      calcDiscount={calculateDiscount}
                      removeDiscount={removeDiscount}
                    />
                  )}

                  {/* Cupom  ninegrid */}
                  {ninegridMotorAble && !totvsVarejoAble && (
                    <CupomInput
                      cupon={coupon}
                      setCupon={setCoupon}
                      hasCoupon={hasCoupon}
                      calcDiscount={calculateNinegridDiscount}
                      removeDiscount={removeDiscount}
                    />
                  )}

                  {/* Coduigo do Vendedor  ninegrid */}
                  {sellerCodeAble && (
                    <SellerCodeInput
                      sellerCode={sellerCode}
                      setSellerCode={setSellerCode}
                      removeSellerCode={removeSellerCode}
                      findSeller={findVendorByCode}
                    />
                  )
                  }

                  {/* Resumo */}
                  <ResumeCart
                    totalWithoutDiscount={totalWithoutDiscount}
                    total={total}
                    deliveryTax={freightFind}
                  />
                </>
              )}
            </div>
            {order && order.products.length > 0 && (
              <ButtonCheckout
                action={async () => {
                  if (!canWithdraw && typeFreight === "delivery" && cep) {
                    setFreightFind(0);
                    toastComponent.openToast(
                      "warning",
                      `Informe um CEP válido`,
                      5000
                    );
                    return;
                  }
                  if (validShift) {
                    const successStock = await verifyStock();
                    if (successStock) {
                      localStorage.removeItem("qrcodePixPayment");
                      await createCart();
                      await calculateDiscount();
                      await calculateNinegridDiscount(true);
                      trackInitiateCheckout()
                      await chooseAddress();
                    }
                  }
                }}
                label={"Seguir com a Compra"}
                backgroundColor={
                  config?.webappcolor.webappbutton
                    ? config.webappcolor.webappbutton
                    : "#EAEAEA"
                }
                color={
                  config?.webappcolor.fontbutton
                    ? config?.webappcolor.fontbutton
                    : "#636363"
                }
                marginBottom
              />
            )}
          </div>
        )}

        {!loadingHeader && (
          <Menu
            activeMenu="cart"
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
      </div>
    </div>
  );
};

export { NewCart };
